export default {
    cmsPrefix:
        process.env.NODE_ENV === "development" || process.env.NODE_ENV === undefined ? "" : "/App_Themes/HJ",
};
